import { PackageOpen, PlusCircle } from 'lucide-react'
import React from 'react'
import { useTranslation } from 'next-i18next'
import { Button } from '../ui/button'
import { useRouter } from 'next/router'
import useCart from '@/contexts/useCart'

const EmptyCartState = () => {
  const { t } = useTranslation('experience')
  const router = useRouter()
  const { setDrawerOpen } = useCart()

  return (
    <div className="text-center space-y-2 mt-64">
      <PackageOpen className="mx-auto" />
      <h3>{t('cart_empty', { ns: 'common' })}</h3>
      <p>{t('cart_empty_description', { ns: 'common' })}</p>
    </div>
  )
}

export default EmptyCartState
